<template>
  <div
    v-if="isLoadingGlobal"
    class="global-loading"
  >
    <ProgressSpinner
      stroke-width="1"
      animation-duration="1.5s"
      aria-label="Loading"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useLoading } from '@/composables/useLoading';
import ProgressSpinner from 'primevue/progressspinner';

export default defineComponent({
  components: {
    ProgressSpinner,
  },
  setup() {
    const { isLoadingGlobal } = useLoading();

    return { isLoadingGlobal };
  },
});
</script>

<style scoped>
.global-loading {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.global-loading :deep(.p-progressspinner-circle) {
  stroke: #7190a6;
  animation: p-progressspinner-dash 2s ease-in-out infinite;
}
</style>
  